import { Link } from '@qonsoll/react-design'
import styled from 'styled-components'

const StyledLink = styled(Link)`
max-width: ${({ breakpoints }) => (breakpoints?.xxl ? '600px' : '400px')}}
`
export default StyledLink
